<script setup>
import { ref } from "vue";

const dialog = ref(false);

const emit = defineEmits(["confirm"]);

const toggleDialog = () => {
  dialog.value = !dialog.value;
};
</script>

<template>
  <v-btn color="error" size="small" @click="toggleDialog">
    <v-icon icon="mdi-delete" /> Delete
  </v-btn>

  <v-dialog v-model="dialog" width="auto">
    <v-card
      max-width="400"
      prepend-icon="mdi-delete"
      text="This entity will be deleted"
      title="Are you sure?"
    >
      <template #actions>
        <v-btn
          class="ms-auto"
          text="Ok"
          color="error"
          @click="emit('confirm')"
        />
        <v-btn class="ms-auto" text="Cancel" @click="toggleDialog" />
      </template>
    </v-card>
  </v-dialog>
</template>
